import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CreateNewPharmacyFormValuesType } from "~/common/types/pharmacyForm";
import { getPatientPharmaciesApi } from "./getPatientPharmaciesApi";
import { patientPharmaciesQueryKey } from "./patientPharmaciesQueryKey";

export const useCreatePatientPharmacy = (
  handleCloseModal: () => void,
  patientId?: string,
) => {
  const queryClient = useQueryClient();
  const api = getPatientPharmaciesApi(patientId);

  const { mutate: createPatientPharmacyMutation, isPending } = useMutation({
    mutationFn: (pharmacy: CreateNewPharmacyFormValuesType) =>
      api.createPharmacy(pharmacy),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: patientPharmaciesQueryKey(patientId),
      });
      handleCloseModal();
    },
  });

  return { createPatientPharmacyMutation, isPending };
};
